import { useCallback } from 'react';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { cloneDeep } from 'lodash';
import { useBroadcast } from '../../../common/broadcast-channel/use-broadcast';
import { AmlCallView, PhoneCallView } from '../../../phone-calls/types';
import { useViewLocationOnMap } from '../../../location/hooks/use-view-location-on-map';
import { ConsolidatedLocationView } from '@mark43/rms-api';

export function useViewCallOnMap() {
    const viewLocationOnMap = useViewLocationOnMap();
    const { disableLegacyMapAndSearches, mapWindowEnabled } = useEnabledFeatures();
    const { postMessage: legacyStoreBroadcastPostMessage } = useBroadcast('legacy-store-broadcast');

    return useCallback(
        ({
            amlCallView,
            phoneCallView,
            location,
            dontFocusOrOpenMap,
            shouldFocusAml,
            shouldClearAmlCall,
            shouldClearPhoneCall,
        }: {
            amlCallView?: AmlCallView;
            phoneCallView?: PhoneCallView;
            location?: ConsolidatedLocationView;
            shouldClearAmlCall?: boolean;
            shouldClearPhoneCall?: boolean;
            dontFocusOrOpenMap?: boolean;
            shouldFocusAml?: boolean;
        }) => {
            if (phoneCallView) {
                const phoneCall = {
                    ...cloneDeep(phoneCallView),
                    latitude: phoneCallView.normalizedPhoneCallDisplay.latFloat,
                    longitude: phoneCallView.normalizedPhoneCallDisplay.lngFloat,
                };
                if (disableLegacyMapAndSearches || mapWindowEnabled) {
                    viewLocationOnMap({
                        location,
                        shouldClearAmlCall,
                        phoneCallView: phoneCall,
                        doNotFocus: dontFocusOrOpenMap ?? false,
                    });
                } else {
                    legacyStoreBroadcastPostMessage({
                        type: 'VIEW_PHONE_CALL_ON_AVL_MAP',
                        payload: {
                            phoneCallView: phoneCall,
                            dontFocusOrOpenMap: dontFocusOrOpenMap ?? false,
                        },
                    });
                }
            }
            if (amlCallView && (disableLegacyMapAndSearches || mapWindowEnabled)) {
                const amlCall = {
                    ...cloneDeep(amlCallView),
                    latitude: amlCallView.normalizedPhoneCallDisplay.latFloat,
                    longitude: amlCallView.normalizedPhoneCallDisplay.lngFloat,
                };

                viewLocationOnMap({
                    location,
                    shouldFocusAml,
                    shouldClearPhoneCall,
                    amlCallView: amlCall,
                    doNotFocus: dontFocusOrOpenMap ?? false,
                });
            }
        },
        [
            legacyStoreBroadcastPostMessage,
            disableLegacyMapAndSearches,
            mapWindowEnabled,
            viewLocationOnMap,
        ]
    );
}
